// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__n6sdA","info":"UpdateTermsInfo_info__2rdF7"};